import { checkTimeAvailability } from './daypartMenuAvailability';

export default (
  purchase?: PurchaseWithTotals,
  items?: Items,
  // ????
  // TODO: create type for this, not sure why this is an any
  daypartConfig?: any,

  dateTimeSelected?: string,
): boolean => {
  if (!purchase) return false;
  const { item: rootItem, choicesWithQuantity, sizeId } = purchase;

  const dayPartTimeBracket = daypartConfig
    ? daypartConfig.dayPartTimeBracket
    : 0;
  const isComposite = !!rootItem.sizes.length;
  const item =
    (isComposite && rootItem.sizes.find(s => s.id === sizeId)) || rootItem;

  const { availability, days, start, end } = item;

  let stagePurchaseAvail = checkTimeAvailability({
    availability,
    days,
    start,
    end,
    timeBracket: dayPartTimeBracket,
    dateTimeSelected,
  });

  if (!items) return availability ? stagePurchaseAvail : true;

  choicesWithQuantity.forEach(c => {
    const choice = items[c.id];
    const { availability, days, start, end } = choice;
    stagePurchaseAvail =
      stagePurchaseAvail &&
      (availability
        ? checkTimeAvailability({
            availability,
            days,
            start,
            end,
            timeBracket: dayPartTimeBracket,
            dateTimeSelected,
          })
        : true);
  });
  return stagePurchaseAvail;
};
